import React from "react";
import { string, objectOf, number, oneOfType, shape, object, array, func, oneOf } from "prop-types";
import { GatsbyImage } from "gatsby-plugin-image";
import { Helmet } from "react-helmet";

const Img = ({
	className,
	style,
	fluid,
	title,
	alt,
	aspectRatio,
	imgStyle,
	backgroundColor,
	onLoad,
	onStartLoad,
	onError,
	Tag,
	objectFit,
	objectPosition,
	loading,
	source,
	src,
	wrapperClassName,
	svg,
	layout,
}) => {
	if (fluid) {
		return (
			<>
				{fluid.preLoad && (
					<Helmet>
						<link
							rel="preload"
							as="image"
							href={fluid?.src}
							imageSrcSet={fluid?.srcSet}
							imageSizes={fluid?.sizes}
						/>
					</Helmet>
				)}
				<GatsbyImage
					image={fluid}
					alt={alt}
					title={title}
					style={style}
					className={wrapperClassName}
					imgStyle={imgStyle}
					backgroundColor={backgroundColor}
					onLoad={onLoad}
					onStartLoad={onStartLoad}
					onError={onError}
					as={Tag}
					objectFit={objectFit}
					objectPosition={objectPosition}
					aspectRatio={aspectRatio ?? fluid.aspectRatio}
					loading={loading}
					layout={layout}
				/>
			</>
		);
	}
	if (src || svg?.dataURI)
		return <img src={src || svg?.dataURI} alt={alt} title={title} className={wrapperClassName} />;
	if (source) {
		return (
			<picture>
				<source srcSet={source.srcSet} sizes={source.sizes} />
				<img
					src={source.src}
					alt={alt}
					title={title}
					style={style}
					className={className}
					srcSet={source.srcSet}
					sizes={source.sizes}
					// eslint-disable-next-line react/no-unknown-property
					effect="blur"
				/>
			</picture>
		);
	}
	return <></>;
};

Img.propTypes = {
	fluid: oneOfType([object, array]),
	title: string,
	alt: string.isRequired,
	aspectRatio: number,
	imgStyle: objectOf(oneOfType([string, number])),
	backgroundColor: string,
	onLoad: func,
	onStartLoad: func,
	onError: func,
	Tag: string,
	objectFit: string,
	objectPosition: string,
	loading: oneOf(["lazy", "eager", "auto"]),
	source: shape({
		src: string,
		srcSet: string,
		sizes: string,
	}),
	svg: shape({
		dataURI: string,
	}),
	className: string,
	style: objectOf(oneOfType([string, number])),
	src: string,
	wrapperClassName: string,
	layout: string,
};
Img.defaultProps = {
	className: "",
	style: {},
	fluid: undefined,
	aspectRatio: undefined,
	svg: undefined,
	title: undefined,
	imgStyle: {},
	backgroundColor: undefined,
	onLoad: undefined,
	onStartLoad: undefined,
	onError: undefined,
	Tag: "div",
	objectFit: undefined,
	objectPosition: undefined,
	loading: "lazy",
	source: undefined,
	src: undefined,
	/**
	 * The image lazy load component has a wrapper (span) we can add class to customize its style
	 */
	wrapperClassName: "",
	layout: "fullWidth",
};

export default Img;
export { Img };
